<template>
  <div class="scheme-investment-estimate">
    <SimpleTable
      ref="schemeInvestmentEstimate"
      table-code="schemeInvestmentEstimate"
      :menus="['查询', '批量修改', '插入', '批量删除']"
      :rightFrozenColCount="1"
      :leftFrozenColCount="1"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      @modify-data-change="onModifyDataChange"
    />
    <DesignDetail ref="designDetailRef" @close="getTable" />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, getOptions, addCbFn } from '@/utils/index'
import DesignDetail from './DesignDetail.vue'

export default {
  name: 'SchemeInvestmentEstimate',
  components: {
    SimpleTable,
    DesignDetail
  },
  data() {
    return {
      // 页面数据
      columns: [
        {
          field: 'name',
          title: '概算名称',
          canEdit: true,
          canModify: true
        },
        {
          field: 'pieName',
          title: '对应估算',
          width: 160,
          canModify: true,
          ...getOptions(
            {
              title: '对应估算',
              key: 'pieName',
              options: () => this.getOieOptions(),
              confirm: (selectedCellInfos, res) => {
                const row = res[0][0].originData
                selectedCellInfos.forEach(cells => {
                  const obj = cells[0].originData
                  this.$set(obj, 'pieName', row.name)
                  this.$set(obj, 'pieId', row.id)
                })
              }
            },
            false
          )
        },
        // {
        //   field: 'preliminaryDesignOptionsName',
        //   title: '设计方案',
        //   canModify: true,
        //   ...getOptions(
        //     {
        //       title: '设计方案',
        //       key: 'preliminaryDesignOptionsName',
        //       options: () => this.getSchemeOptions(),
        //       confirm: (selectedCellInfos, res) => {
        //         const row = res[0][0].originData
        //         selectedCellInfos.forEach(cells => {
        //           const obj = cells[0].originData
        //           this.$set(obj, 'preliminaryDesignOptionsName', row.name)
        //           this.$set(obj, 'preliminaryDesignOptionsId', row.id)
        //         })
        //       }
        //     },
        //     false
        //   )
        // },
        { field: 'projectName', title: '项目名称' },
        { field: 'regionName', title: '所在区域' },
        { field: 'address', title: '详细地址' },
        { field: 'measurementUnit', title: '计量单位' },
        { field: 'constructionScale', title: '建筑规模' },
        { field: 'estimateAmount', title: '概算金额' },
        { field: 'costIndicator', title: '造价指标' },
        { field: 'breakEvenPoint', title: '盈亏平衡点' },
        { field: 'profitCycle', title: '盈利周期' },

        {
          field: 'operation',
          title: '操作',
          width: 80,
          cellType: 'text',
          buttons: [
            {
              action: 'openModal',
              text: '设计概算',
              click: (row, record) => this.openModal(row, record),
              style: { backgroundColor: '#ff4d4f', color: '#ffffff' }
            }
          ]
        }
      ],
      tableData: [{ id: 1 }],
      loading: false
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getTable()
    },
    async getTable() {
      this.tableData = []
      this.loading = true
      const res = await this.$service.get('/design-budget-estimate/list', {})
      this.loading = false
      res.data.forEach(e => {
        e.resultPictureFileUrl = '/file' + e.resultPictureFileUrl
      })
      this.tableData = sortRecords(res?.data || [])
    },

    async getSchemeOptions() {
      const res = await this.$service.get(
        '/preliminaryDesignOptions/queryList',
        {}
      )
      return sortRecords(res?.data || [])
    },

    async getOieOptions() {
      const res = await this.$service.get('/plan-investment-estimate/list', {})
      return sortRecords(res?.data || [])
    },

    // openModal
    openModal(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.designDetailRef.show(this.tableData[row])
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/design-budget-estimate/batch',
        getModifyData,
        cleanModifyData
      )

      this.getTable()
    }
  }
}
</script>

<style scoped>
.scheme-investment-estimate {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
</style>
